import { render } from "./UserEditModal.vue?vue&type=template&id=1fa8e85b&scoped=true"
import script from "./UserEditModal.vue?vue&type=script&lang=js"
export * from "./UserEditModal.vue?vue&type=script&lang=js"

import "./UserEditModal.vue?vue&type=style&index=0&id=1fa8e85b&lang=css&scoped=true"

import exportComponent from "/var/www/test.mciafc.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fa8e85b"]])

export default __exports__